module.exports = __webpack_public_path__ + "static/6h-hungry-ee176e64a5c37d5022403cf787dacddd.png";